const PrivacyPolicy = () => {
  return (
    <div className="mx-auto max-w-5xl space-y-4 bg-white px-4 py-6 text-sm leading-snug text-gray-800">
      <h1 className="mb-4 text-xl font-bold">
        Regulify.AI Platform Privacy Policy
      </h1>

      <p>
        This Privacy Policy (“Privacy Policy”) explains how RegulifyAI LLC (the
        “Company”, “we”, “us”, or “our”) handles your Personal Data when you use
        our web platform, located at{" "}
        <a
          href="https://app.Regulify.AI/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          https://app.Regulify.AI.com
        </a>{" "}
        (the “Platform”). It also informs you of your privacy rights and how the
        law protects those rights.
      </p>

      <p>
        “Personal Data” means information relating to an identified or
        identifiable individual. Depending on your jurisdiction, such as under
        the GDPR, UK GDPR, or CCPA, we act as a “data controller” or “business”.
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">
        1. The Data We Collect About You
      </h2>
      <ul className="list-inside list-disc space-y-1">
        <li>
          <strong>Identity Data:</strong> First and last name
        </li>
        <li>
          <strong>Contact Data:</strong> Email address
        </li>
        <li>
          <strong>Business Data:</strong> Company name, industry, position
        </li>
        <li>
          <strong>User Content:</strong> Inputs, uploads, or feedback
        </li>
        <li>
          <strong>Payment Data:</strong> Payment info (processed by vendors)
        </li>
        <li>
          <strong>Query Data:</strong> Information collected to answer queries
        </li>
        <li>
          <strong>Marketing Data:</strong> Your communication preferences
        </li>
        <li>
          <strong>Usage & Technical Data:</strong> Interactions, IP address,
          browser, OS
        </li>
        <li>
          <strong>Additional Inquiry Data:</strong> Any extra info provided when
          contacting us
        </li>
      </ul>

      <h2 className="mt-6 mb-2 text-base font-semibold">
        2. How We Collect Your Personal Data
      </h2>
      <ul className="list-inside list-disc space-y-1">
        <li>Direct interactions (e.g. registration, contacting us)</li>
        <li>Automated technologies (e.g. cookies, logs)</li>
        <li>
          Third-party services and data sources (e.g. analytics, auth providers)
        </li>
      </ul>

      <h2 className="mt-6 mb-2 text-base font-semibold">
        3. How We Use Your Personal Data
      </h2>
      <p>
        We only use your data as permitted by law. This includes fulfilling
        contracts, complying with legal obligations, protecting legitimate
        interests, or based on your consent.
      </p>

      <ul className="list-inside list-disc space-y-1">
        <li>To provide and improve the Platform</li>
        <li>To manage our relationship with you</li>
        <li>To send marketing and personalized content</li>
        <li>To manage payments and prevent fraud</li>
        <li>To respond to legal requests or disputes</li>
      </ul>

      <h2 className="mt-6 mb-2 text-base font-semibold">
        4. Sharing Your Personal Data
      </h2>
      <p>
        We may share your data with service providers, payment processors, legal
        authorities, or potential business partners. Query data may be shared
        with other users.
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">5. Minors</h2>
      <p>
        Our Platform is not for users under 13. If you're a parent or guardian
        and believe your child provided us with data, contact us immediately.
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">
        6. International Transfers
      </h2>
      <p>
        Your data may be transferred internationally under protective clauses or
        with your consent.
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">7. Data Security</h2>
      <p>
        We use security measures but cannot guarantee full protection of your
        data due to the nature of the internet.
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">8. Data Retention</h2>
      <p>
        We keep your data as long as needed to meet legal, contractual, and
        service needs.
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">9. Your Rights</h2>
      <ul className="list-inside list-disc space-y-1">
        <li>Request access, correction, or erasure</li>
        <li>Object or restrict processing</li>
        <li>Data portability</li>
        <li>Withdraw consent at any time</li>
      </ul>

      <h2 className="mt-6 mb-2 text-base font-semibold">
        Cookies and Tracking
      </h2>
      <p>
        We use various cookies (necessary, performance, functional, media,
        targeting). You may disable cookies in your browser settings.{" "}
        <a
          href="https://www.allaboutcookies.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Learn more here
        </a>
        .
      </p>

      <h2 className="mt-6 mb-2 text-base font-semibold">Third-Party Links</h2>
      <p>
        Our Platform may contain links to third-party websites. We do not
        control and are not responsible for their privacy practices.
      </p>

      <p className="mt-6">
        If you have any questions or concerns about this Privacy Policy, please
        contact us at{" "}
        <a
          href="mailto:admin@regulify.ai.com"
          className="text-blue-600 underline"
        >
          admin@regulify.ai.com
        </a>
        .
      </p>
    </div>
  );
};
export default PrivacyPolicy;
